export const IconSettings: {
  name: 'icon_settings-19d0bfdf0828'
} = {
  name: 'icon_settings-19d0bfdf0828'
}
